<template>
    <div class="update-menu-container">
        <div class="update-menu-nav">
            <div class="menu-nav-title">
                <span>编辑文档菜单</span>
                <a-tooltip placement="top">
                    <template slot="title">
                        <span>返回文档</span>
                    </template>
                    <a-icon type="rollback"
                            class="menu-edit-icon"
                            @click="()=>{this.$router.push('/')}" />
                </a-tooltip>
            </div>
            <div class="menu-nav-tree">
                <a-tree class="draggable-tree"
                        show-line
                        default-expand-all
                        :default-selected-keys="treeSelectedKeys"
                        :tree-data="menuTreeData"
                        @select="onMenuTreeSelect" />
            </div>
            <div class="add-menu-btn">
                <a-button
                    icon="plus"
                    style="font-size:14px"
                    @click="addMenu">新增菜单</a-button>
            </div>
        </div>
        <div class="update-menu-content">
            <div class="current-menu-item">
                <span style="font-size:14px;">当前菜单: <b>{{currentSelectedTree.title}}</b></span>
            </div>
            <div class="content-operator-item"
                 style="margin-top:0;"
                 v-if="!isAdd">
                <div class="operator-item-title">创建子菜单
                    <a-tooltip>
                        <template slot="title">
                            当前菜单为第4级菜单，无法创建子菜单
                        </template>
                        <a-icon type="info-circle"
                                style="color:#ff9900;"
                                v-if="currentSelectedTree.zIndex === '5'" />
                    </a-tooltip>
                </div>
                <div class="operator-item-div">
                    <a-form-model ref="createSubForm"
                                  :model="createSubForm"
                                  :rules="createSubRule"
                                  :label-col="{span:4}"
                                  :wrapper-col="{span:15}">
                        <a-form-model-item label="父菜单"
                                           class="marginbot20 margintop10">
                            <a-tree-select v-model="createSubForm.parentId"
                                           style="width: 100%"
                                           :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                           :tree-data="formTreeData"
                                           :disabled="currentSelectedTree.zIndex === '5'"
                                           placeholder="请选择"
                                           allowClear>
                            </a-tree-select>
                        </a-form-model-item>
                        <a-form-model-item label="菜单名"
                                           class="marginbot20"
                                           prop="title">
                            <a-input v-model="createSubForm.title"
                                     :disabled="currentSelectedTree.zIndex ==='5'"
                                     :maxLength="32"
                                     placeholder="请输入菜单名称" />
                        </a-form-model-item>
                        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                            <a-button type="primary"
                                      :disabled="currentSelectedTree.zIndex === '5'"
                                      :loading="createLoading"
                                      @click="submit">保存</a-button>
                            <a-button type="default"
                                      :disabled="currentSelectedTree.zIndex === '5'"
                                      style="margin-left:6px;"
                                      @click="resetCreateForm">重置</a-button>
                        </a-form-model-item>
                    </a-form-model>
                </div>
            </div>
            <div class="content-operator-item">
                <div class="operator-item-title">编辑菜单</div>
                <div class="operator-item-div">
                    <a-form-model ref="editSubForm"
                                  :model="editSubForm"
                                  :rules="editSubRule"
                                  :label-col="{span:4}"
                                  :wrapper-col="{span:15}">
                        <a-form-model-item label="菜单名"
                                           class="marginbot20"
                                           prop="title">
                            <a-input v-model="editSubForm.title"
                                     :maxLength="32"
                                     placeholder="请输入菜单名称" />
                        </a-form-model-item>
                        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                            <a-button type="primary"
                                      :loading="editLoading"
                                      @click="save">保存</a-button>
                            <a-button type="default"
                                      style="margin-left:6px;"
                                      @click="resetEditForm">重置</a-button>
                        </a-form-model-item>
                    </a-form-model>
                </div>
            </div>
            <div style="margin-top:24px">
                <a-button type="danger"
                          :loading="removeLoading"
                          @click="removeById">删除</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
export default {
    name: 'updateMenuDrawer',
    data () {
        return {
            dbData: [], // 当前菜单数据
            treeSelectedKeys: [], // 左侧菜单Tree选中keys
            menuTreeData: [], // 左侧菜单树
            currentSelectedTree: {}, // 当前选中key
            formTreeData: [], // 表单树形结构
            createLoading: false,
            createSubForm: {
                parentId: undefined,
                title: ''
            },
            createSubRule: {
                title: [
                    { required: true, message: '该字段不能为空', trigger: 'blur' }
                ]
            },
            editLoading: false,
            editSubForm: {
                title: ''
            },
            editSubRule: {
                title: [
                    { required: true, message: '该字段不能为空', trigger: 'blur' }
                ]
            },
            removeLoading: false,
            isAdd: false
        }
    },
    computed: {
        restUrl () {
            return this.$store.state.restUrl
        }
    },
    created () {
        // 初始化数据
        this.initData()
    },
    methods: {
        initData () {
            fetch(this.restUrl + '/list').then(response => response.json()).then(result => {
                // console.log(JSON.stringify(this.dbData))
                this.dbData = result.filter(item => item.title !== '基础服务')
                // 处理数据
                this.menuTreeData = this.parseData()
                // 父级菜单
                this.formTreeData = this.parseParentData()
                // 初始化创建菜单时的默认选中
                this.createSubForm.parentId = this.currentSelectedTree.id
            })
        },
        // 初始化tree数据
        parseData () {
            const cloneData = JSON.parse(JSON.stringify(this.dbData))
            return cloneData.filter((father, index) => {
                if (index === 0) {
                    this.treeSelectedKeys.push(father.id)
                    this.currentSelectedTree = father
                    this.editSubForm.title = father.title
                }
                father.key = father.id
                father.value = father.id
                const branchArr = cloneData.filter(child => father.id === child.parentId)
                if (branchArr.length > 0) {
                    father.children = branchArr
                }
                return father.parentId === '0'
            })
        },
        // 初始化tree数据，去掉了3级数据
        parseParentData () {
            const cloneData = JSON.parse(JSON.stringify(this.dbData))
            return cloneData.filter((father) => {
                father.key = father.id
                father.value = father.id
                const branchArr = cloneData.filter(child => father.id === child.parentId && parseInt(child.zIndex) < 5)
                if (branchArr.length > 0) {
                    father.children = branchArr
                }
                return father.parentId === '0'
            })
        },
        // tree选中事件
        onMenuTreeSelect (selectedKeys, info) {
            this.treeSelectedKeys = selectedKeys
            const tableData = JSON.parse(JSON.stringify(this.dbData))
            for (let i = 0; i < tableData.length; i++) {
                const item = tableData[i]
                if (item.id === info.node.value) {
                    this.currentSelectedTree = item
                    this.createSubForm.parentId = item.id
                    this.editSubForm.title = item.title
                    break
                }
            }
        },
        addMenu () {
            this.isAdd = true
            this.currentSelectedTree = {}
            this.editSubForm.title = ''
        },
        // 提交-创建子菜单
        submit () {
            this.$refs.createSubForm.validate(valid => {
                if (valid) {
                    const newObj = {
                        title: this.createSubForm.title,
                        parentId: this.createSubForm.parentId || '0'
                    }
                    // 获取父级数据
                    if (newObj.parentId === '0') {
                        newObj.zIndex = 1
                    } else {
                        // 获取父级菜单zIndex属性，并加1
                        const tableData = JSON.parse(JSON.stringify(this.dbData))
                        for (let i = 0; i < tableData.length; i++) {
                            const item = tableData[i]
                            if (item.id === newObj.parentId) {
                                newObj.zIndex = parseInt(item.zIndex) + 1
                                break
                            }
                        }
                    }
                    // 创建
                    this.createLoading = true
                    fetch(this.restUrl + '/create', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: qs.stringify(newObj)
                    }).then(response => response.json()).then(result => {
                        if (result.status) {
                            setTimeout(() => {
                                this.createLoading = false
                                this.initData()
                                this.resetCreateForm()
                            }, 500)
                        }
                    }).catch(err => {
                        console.error(err)
                    })
                }
            })
        },
        // 重置-创建子菜单
        resetCreateForm () {
            this.$refs.createSubForm.resetFields()
        },
        saveMenu () {
            const data = {
                title: this.editSubForm.title,
                parentId: '0',
                zIndex: '1'
            }
            fetch(this.restUrl + '/createMenu', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: qs.stringify(data)
            }).then(res => res.json()).then(result => {
                if (result.status) {
                    setTimeout(() => {
                        this.isAdd = false
                        this.editLoading = false
                        this.initData()
                        this.resetEditForm()
                    }, 500)
                }
            }).catch(e => {
                this.editLoading = false
                console.log(e)
            })
        },
        // 保存-编辑菜单
        save () {
            this.$refs.editSubForm.validate(valid => {
                if (valid) {
                    this.editLoading = true
                    if (this.isAdd) {
                        this.saveMenu()
                        return
                    }
                    fetch(this.restUrl + '/update/' + this.currentSelectedTree.id, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: qs.stringify({ title: this.editSubForm.title })
                    }).then(response => response.json()).then(result => {
                        if (result.status) {
                            setTimeout(() => {
                                this.editLoading = false
                                this.initData()
                                this.resetEditForm()
                            }, 500)
                        }
                    }).catch(err => {
                        console.error(err)
                    })
                }
            })
        },
        // 重置-编辑菜单
        resetEditForm () {
            this.$refs.editSubForm.resetFields()
        },
        removeById () {
            this.removeLoading = true
            fetch(this.restUrl + '/remove/' + this.currentSelectedTree.id, {
                method: 'delete'
            }).then(response => response.json()).then(result => {
                if (result.status) {
                    setTimeout(() => {
                        this.removeLoading = false
                        this.initData()
                    }, 500)
                }
            })
        }
    }
}
</script>
<style lang="less">
.ant-tree.ant-tree-show-line li span.ant-tree-switcher {
    background: #f2f5fc;
}
</style>
<style lang="less" scoped>
.update-menu-container {
    width: 100%;
    height: 100%;
    display: flex;
    .update-menu-nav {
        position: relative;
        width: 240px;
        height: 100%;
        border-right: 1px solid #e9e9e9;
        overflow-y: auto;
        background: #f2f5fc;
        .menu-nav-title {
            position: relative;
            width: 100%;
            height: 50px;
            font-size: 16px;
            color: #3d3f43;
            line-height: 50px;
            padding-left: 15px;
            border-bottom: 1px solid #e4e6f3;
            transition: all 0.3s;
            font-weight: 700;
            .menu-edit-icon {
                position: absolute;
                right: 15px;
                top: 18px;
                cursor: pointer;
                &:hover {
                    color: #0099d7;
                }
            }
        }
        .menu-nav-tree {
            width: 100%;
            height: calc(~'100% - 90px');
            padding: 5px 10px;
            font-size: 14px;
            overflow: hidden;
            &:hover {
                overflow-y: auto;
            }
        }
        .add-menu-btn {
            position: absolute;
            padding-left: 5px;
            width: 100%;
            height: 40px;
            bottom: 4px;
            left: 0;
            background: #f2f5fc
        }
    }
    .update-menu-content {
        width: calc(~'100% - 240px');
        height: 100%;
        padding: 0 20px 20px 20px;
        .current-menu-item {
            width: 100%;
            height: 50px;
            line-height: 50px;
        }
        .content-operator-item {
            background: #f1f3f6;
            margin-top: 20px;
            width: 70%;
            .operator-item-title {
                width: 100%;
                height: 40px;
                font-size: 14px;
                font-weight: 600;
                padding-left: 20px;
                line-height: 40px;
                border-bottom: 1px solid #e9e9e9;
            }
            .operator-item-div {
                width: 100%;
                padding-bottom: 1px;
            }
        }
        .marginbot20 {
            margin-bottom: 20px;
        }
        .margintop10 {
            margin-top: 10px;
        }
    }
}
</style>
